export { default } from "./Company";



// WEBPACK FOOTER //
// ./src/components/emission/client-summary/Company/index.js